import React, { useState, useEffect } from 'react';
import { Link, Element } from 'react-scroll';
import logo from "./components/logonova.png"; // Seu logo original
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import {
  faCode, faTv, faMobileAlt, faBars, faTimes,
  faRocket, faMapPin, faThumbsUp, faCheck, faSearch, faArrowRight,
  faQrcode, faDumbbell, faRobot, faChartPie, faLightbulb, faDollarSign
} from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import Trabalhos from './components/Trabalhos'; // Certifique-se que Trabalhos.js foi atualizado para este tema!
import Slider from "react-slick";
import { motion, AnimatePresence } from 'framer-motion';

// --- CSS ATUALIZADO (Fonte Poppins e Novas Cores) ---
const carouselStyles = `
  /* Importação da Fonte Poppins */
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;900&display=swap');

  /* Aplicando a fonte Poppins como padrão */
  .font-poppins {
    font-family: 'Poppins', sans-serif;
  }

  .slick-dots {
    bottom: -40px;
  }
  .slick-dots li button:before {
    font-size: 12px;
    color: #d1d5db; /* cinza */
    opacity: 1;
    transition: all 0.3s ease;
  }
  .slick-dots li.slick-active button:before {
    color: #242A53; /* NOVA COR PRIMÁRIA */
    transform: scale(1.5);
  }
  .hero-bg-pattern {
    /* Padrão de fundo bem sutil */
    background-image: radial-gradient(#e5e7eb 1px, transparent 1px);
    background-size: 25px 25px;
    opacity: 0.3;
  }
  html {
    scroll-behavior: smooth;
  }
`;

// --- NOSSAS VARIANTES DE ANIMAÇÃO (Framer Motion) ---
const staggerContainer = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const fadeInUp = {
  hidden: { y: 30, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100, damping: 12 } },
};

const fadeInLeft = {
  hidden: { x: -50, opacity: 0 },
  show: { x: 0, opacity: 1, transition: { type: 'spring', stiffness: 100, damping: 12 } },
};

const fadeInRight = {
  hidden: { x: 50, opacity: 0 },
  show: { x: 0, opacity: 1, transition: { type: 'spring', stiffness: 100, damping: 12 } },
};

const scaleIn = {
  hidden: { scale: 0.8, opacity: 0 },
  show: { scale: 1, opacity: 0.9, transition: { type: 'spring', stiffness: 120, damping: 10, delay: 0.3 } },
};


const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 3;
  const [searchTerm, setSearchTerm] = useState('');

  const toggleMobileMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleSearch = (event) => {
     if (event.key === 'Enter') {
       const term = searchTerm.toLowerCase().trim();
       if (!term) return;

       const elements = document.querySelectorAll('h1, h2, h3, p, span, a, li');
       let foundElement = null;

       elements.forEach((el) => {
         const text = el.innerText?.toLowerCase();
         if (text && text.includes(term) && !foundElement) {
           foundElement = el;
         }
       });

       if (foundElement) {
         foundElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
         foundElement.style.transition = 'background-color 0.3s ease';
         foundElement.style.backgroundColor = 'rgba(192, 204, 204, 0.3)'; // Destaque com a cor nova
         setTimeout(() => {
           foundElement.style.backgroundColor = '';
         }, 2500);
         if(isMenuOpen) toggleMobileMenu();
       } else {
         alert('Item não encontrado!');
       }
     }
  };

  const settingsDois = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    dots: true,
    arrows: false,
    centerMode: true,
    centerPadding: "20px",
    beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  const beneficios = [
    { icon: faChartPie, text: "Aumento de produtividade: Automatize processos e reduza o tempo gasto em tarefas manuais." },
    { icon: faLightbulb, text: "Soluções inovadoras: Utilize tecnologias recentes para aprimorar seu negócio e se destacar." },
    { icon: faDollarSign, text: "Redução de custos: Diminua gastos com erros, retrabalho e manutenção de sistemas antigos." }
  ];


  return (
    <>
      <style>{carouselStyles}</style>
      {/* APLICANDO A FONTE POPPINS E NOVAS CORES DE TEXTO PADRÃO */}
      <div className="bg-white text-gray-800 font-poppins antialiased overflow-x-hidden">
        
        <AnimatePresence>
          {isMenuOpen && (
            <>
              {/* Overlay */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 md:hidden"
                onClick={toggleMobileMenu}
              ></motion.div>

              {/* Sidebar (Cor primária no texto) */}
              <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: 0 }}
                exit={{ x: "-100%" }}
                transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                className="fixed top-0 left-0 h-full w-80 bg-white border-r border-gray-200 text-[#242A53] z-50 md:hidden shadow-2xl"
              >
                <div className="flex justify-between items-center p-5 border-b border-gray-100">
                  <img src={logo} alt="Schimborn Tech Logo" className="h-10 w-10" />
                  <div className="text-2xl cursor-pointer text-gray-500 p-2 rounded-full hover:bg-gray-100 transition-colors" onClick={toggleMobileMenu}>
                    <FontAwesomeIcon icon={faTimes} />
                  </div>
                </div>
                
                <motion.ul 
                  className="flex flex-col p-5 space-y-3 mt-4"
                  variants={staggerContainer}
                  initial="hidden"
                  animate="show"
                >
                  <motion.li variants={fadeInUp}><Link to="apresentacaosch" smooth={true} duration={500} offset={-80} onClick={toggleMobileMenu} className="cursor-pointer py-3 px-4 rounded-lg hover:bg-gray-100 hover:text-[#3a417a] block text-lg font-semibold transition-colors duration-200">Quem Somos</Link></motion.li>
                  <motion.li variants={fadeInUp}><Link to="enviar-mensagem" smooth={true} duration={500} offset={-80} onClick={toggleMobileMenu} className="cursor-pointer py-3 px-4 rounded-lg hover:bg-gray-100 hover:text-[#3a417a] block text-lg font-semibold transition-colors duration-200">Serviços</Link></motion.li>
                  <motion.li variants={fadeInUp}><Link to="trabalhos-section" smooth={true} duration={500} offset={-80} onClick={toggleMobileMenu} className="cursor-pointer py-3 px-4 rounded-lg hover:bg-gray-100 hover:text-[#3a417a] block text-lg font-semibold transition-colors duration-200">Portfólio</Link></motion.li>
                  <motion.li variants={fadeInUp}><Link to="faleconosco" smooth={true} duration={500} onClick={toggleMobileMenu} className="cursor-pointer py-3 px-4 rounded-lg hover:bg-gray-100 hover:text-[#3a417a] block text-lg font-semibold transition-colors duration-200">Fale Conosco</Link></motion.li>
                </motion.ul>
                
                <div className="p-5 absolute bottom-5 w-full border-t border-gray-100 pt-5">
                   <div className="relative">
                     <input
                       className="w-full pl-10 pr-4 py-3 rounded-full bg-gray-100 border border-gray-200 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#242A53]"
                       placeholder="Buscar"
                       value={searchTerm}
                       onChange={(e) => setSearchTerm(e.target.value)}
                       onKeyDown={handleSearch}
                     />
                     <FontAwesomeIcon icon={faSearch} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                   </div>
                 </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>

        {/* --- HEADER COM LOGO CENTRALIZADA NO MOBILE E NOVAS CORES --- */}
        <motion.header 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="fixed top-0 left-0 right-0 z-30 bg-white/95 backdrop-blur-lg border-b border-gray-100 py-4 px-6 
                     grid grid-cols-3 md:flex md:justify-between items-center shadow-sm"
        >
          {/* Botão Hambúrguer (Esquerda no Mobile) */}
          <div className="text-2xl cursor-pointer text-[#242A53] md:hidden z-10 justify-self-start" onClick={toggleMobileMenu}>
            <FontAwesomeIcon icon={faBars} />
          </div>
          
          {/* Logo e Nome da Marca (Centralizado no Mobile, Esquerda no Desktop) */}
          <Link 
            to="apresentacaosch" 
            smooth={true} 
            duration={500} 
            offset={-80} 
            className="flex items-center gap-3 cursor-pointer z-10 
                       col-start-2 justify-center md:justify-start"
          >
            <motion.img 
              src={logo} 
              alt="Schimborn Tech Logo" 
              className="h-10 w-10" 
              whileHover={{ scale: 1.1, rotate: 10 }}
            />
            <span className="text-xl font-bold text-[#242A53] hidden sm:block">Schimborn <span className="text-gray-600">Tech</span></span>
          </Link>

          {/* Links Desktop Centralizados */}
          <nav className="hidden md:flex absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 items-center gap-10">
            <Link to="apresentacaosch" smooth={true} duration={500} offset={-80} className="relative cursor-pointer font-medium text-gray-600 hover:text-[#242A53] transition-colors after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 hover:after:w-full after:bg-[#242A53] after:transition-all after:duration-300">Quem Somos</Link>
            <Link to="enviar-mensagem" smooth={true} duration={500} offset={-80} className="relative cursor-pointer font-medium text-gray-600 hover:text-[#242A53] transition-colors after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 hover:after:w-full after:bg-[#242A53] after:transition-all after:duration-300">Serviços</Link>
            <Link to="trabalhos-section" smooth={true} duration={500} offset={-80} className="relative cursor-pointer font-medium text-gray-600 hover:text-[#242A53] transition-colors after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 hover:after:w-full after:bg-[#242A53] after:transition-all after:duration-300">Portfólio</Link>
          </nav>

          {/* Botão de Contato (Direita Desktop, Oculto Mobile) */}
          <div className="hidden md:flex items-center gap-4 z-10">
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {/* BOTÃO COM DEGRADE SUAVE NOVO */}
              <Link to="faleconosco" smooth={true} duration={500} className="bg-gradient-to-r from-[#242A53] to-[#3a417a] text-white font-semibold py-2.5 px-6 rounded-full shadow-lg shadow-[#242A53]/30 hover:shadow-xl hover:shadow-[#242A53]/40 transition-shadow duration-300 hover:brightness-110">
                Fale Conosco
              </Link>
            </motion.div>
          </div>
        </motion.header>


        {/* Conteúdo Principal */}
        <main className="pt-20">
          {/* Seção Hero - LOGO ACIMA DO TEXTO NO MOBILE */}
          <Element name="apresentacaosch">
            {/* Fundo sem azul claro, usando cinza sutil */}
            <section id="apresentacao" className="relative pt-28 pb-32 px-4 md:px-8 bg-gradient-to-br from-white to-gray-50 overflow-hidden">
              <div className="absolute inset-0 hero-bg-pattern z-0"></div>
              
              <motion.div 
                className="container mx-auto max-w-6xl relative z-10 -mt-10"
                variants={staggerContainer}
                initial="hidden"
                animate="show"
              >
                <div className="flex flex-col md:flex-row items-center justify-between gap-12">
                  {/* Coluna de Texto */}
                  <motion.div className="md:w-1/2 text-center md:text-left" variants={fadeInLeft}>
                    
                    {/* --- LOGO SÓ PARA MOBILE (ACIMA DO TÍTULO) --- */}
                    <motion.img 
                      src={logo} 
                      alt="Schimborn Tech Logo"
                      className="w-28 h-28 mx-auto mb-6 md:hidden" // Centralizado, margin-bottom, hidden on desktop
                      variants={fadeInUp} 
                      animate={{
                        y: [0, -10, 0]
                      }}
                      transition={{
                        duration: 4,
                        repeat: Infinity,
                        ease: "easeInOut"
                      }}
                    />

                    {/* TÍTULO COM A NOVA COR */}
                    <h1 className="text-5xl lg:text-7xl font-extrabold text-[#242A53] leading-tight mb-6" data-search="quem somos">
                      Schimborn <br />
                      <span className="text-gray-700">Tech</span>
                    </h1>
                    <motion.p variants={fadeInUp} className="text-xl md:text-2xl text-gray-600 max-w-lg mx-auto md:mx-0 mb-10 leading-relaxed">
                      Especialistas em <strong>sistemas, sites e aplicativos</strong> que impulsionam o sucesso do seu negócio.
                    </motion.p>
                    
                    {/* Botões */}
                    <motion.div variants={fadeInUp} className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-5">
                      {/* BOTÃO PRIMÁRIO COM NOVA COR E GRADIENTE */}
                      <motion.a 
                        href="https://wa.me/+554288673339" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="w-full sm:w-auto bg-gradient-to-r from-[#242A53] to-[#3a417a] text-white font-bold py-4 px-8 rounded-full transition-all duration-300 shadow-xl shadow-[#242A53]/30 flex items-center justify-center gap-3 hover:brightness-110"
                        whileHover={{ scale: 1.05, y: -2, boxShadow: "0 10px 20px rgba(36, 42, 83, 0.4)" }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <FontAwesomeIcon icon={faWhatsapp} className="text-xl" />
                        Fale com um Especialista
                      </motion.a>
                      <motion.div
                        whileHover={{ scale: 1.05, y: -2 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Link to="trabalhos-section" smooth={true} duration={500} offset={-80}
                          className="w-full sm:w-auto bg-white text-[#242A53] font-bold py-4 px-8 rounded-full border border-gray-200 hover:bg-gray-50 transition-colors duration-300 shadow-md flex items-center justify-center gap-3 cursor-pointer">
                          Ver Projetos
                          <FontAwesomeIcon icon={faArrowRight} className="text-lg" />
                        </Link>
                      </motion.div>
                    </motion.div>
                  </motion.div>

                  {/* Coluna da Logo (SÓ DESKTOP) */}
                  <motion.div 
                    className="hidden md:flex md:w-1/2 justify-center md:justify-end" // Oculto no mobile
                    variants={scaleIn}
                  >
                    <motion.img
                      src={logo}
                      alt="Schimborn Tech Logo Grande"
                      className="w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96"
                      animate={{
                        rotate: [0, 5, -5, 0],
                        y: [0, -10, 0]
                      }}
                      transition={{
                        duration: 5,
                        repeat: Infinity,
                        ease: "easeInOut"
                      }}
                    />
                  </motion.div>
                </div>
              </motion.div>
            </section>
          </Element>

          {/* Seção Trabalhos (Portfolio) */}
          <Element name="trabalhos-section">
            <section className="py-24 px-4 md:px-8 bg-white">
              <div className="container mx-auto text-center max-w-7xl">
                <motion.h2 
                  variants={fadeInUp} 
                  initial="hidden" 
                  whileInView="show"
                  viewport={{ once: true, amount: 0.5 }}
                  className="text-4xl md:text-5xl font-extrabold text-[#242A53] mb-6"
                >
                  Nosso Portfólio
                </motion.h2>
                <motion.p 
                  variants={fadeInUp} 
                  initial="hidden" 
                  whileInView="show" 
                  viewport={{ once: true, amount: 0.5 }}
                  className="text-xl text-gray-600 mb-16 max-w-3xl mx-auto"
                >
                  Explore alguns dos projetos que desenvolvemos e veja como transformamos ideias em soluções digitais eficazes.
                </motion.p>
                <motion.div 
                  variants={fadeInUp} 
                  initial="hidden" 
                  whileInView="show" 
                  viewport={{ once: true, amount: 0.2 }}
                >
                  <Trabalhos />
                </motion.div>
              </div>
            </section>
          </Element>
          
          {/* Seção Objetivos - Fundo cinza sutil, novos ícones */}
          <Element name="objetivos">
            <section id="objetivos" className="py-24 px-4 md:px-8 bg-gradient-to-b from-gray-50 via-white to-gray-50">
              <div className="container mx-auto text-center max-w-6xl">
                <motion.h2 variants={fadeInUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.5 }} className="text-4xl md:text-5xl font-extrabold text-[#242A53] mb-6">Por que somos a escolha certa?</motion.h2>
                <motion.p variants={fadeInUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.5 }} className="text-xl text-gray-600 mb-16 max-w-2xl mx-auto">Nosso diferencial está na combinação de tecnologia de ponta, atendimento próximo e foco nos seus resultados.</motion.p>
                
                <motion.div 
                  className="grid md:grid-cols-3 gap-10"
                  variants={staggerContainer}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.2 }}
                >
                  {/* Card 1 (Ícone com a cor #c0cccc) */}
                  <motion.div 
                    variants={fadeInUp}
                    whileHover={{ y: -10, scale: 1.03 }}
                    transition={{ type: 'spring', stiffness: 300, damping: 10 }}
                    className="group bg-white rounded-3xl p-8 text-left shadow-lg hover:shadow-2xl hover:shadow-[#242A53]/10 border border-transparent hover:border-gray-200 transition-shadow duration-300"
                  >
                    <div className="bg-[#c0cccc]/40 text-[#242A53] w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-md group-hover:bg-[#242A53] group-hover:text-white transition-colors duration-300">
                      <FontAwesomeIcon icon={faRocket} className="text-3xl" />
                    </div>
                    <h3 className="text-2xl font-bold text-[#242A53] mb-3 group-hover:text-[#242A53] transition-colors duration-300">Inovação</h3>
                    <p className="text-gray-700 text-lg leading-relaxed">
                      Utilizamos as tecnologias mais recentes para criar soluções eficientes e preparadas para o futuro.
                    </p>
                  </motion.div>
                  {/* Card 2 */}
                  <motion.div 
                    variants={fadeInUp}
                    whileHover={{ y: -10, scale: 1.03 }}
                    transition={{ type: 'spring', stiffness: 300, damping: 10 }}
                    className="group bg-white rounded-3xl p-8 text-left shadow-lg hover:shadow-2xl hover:shadow-[#242A53]/10 border border-transparent hover:border-gray-200 transition-shadow duration-300"
                  >
                    <div className="bg-[#c0cccc]/40 text-[#242A53] w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-md group-hover:bg-[#242A53] group-hover:text-white transition-colors duration-300">
                      <FontAwesomeIcon icon={faMapPin} className="text-3xl" />
                    </div>
                    <h3 className="text-2xl font-bold text-[#242A53] mb-3 group-hover:text-[#242A53] transition-colors duration-300">Proximidade</h3>
                    <p className="text-gray-700 text-lg leading-relaxed">
                      Atendimento local em São Mateus do Sul, garantindo suporte ágil e comunicação clara durante todo o projeto.
                    </p>
                  </motion.div>
                  {/* Card 3 */}
                  <motion.div 
                    variants={fadeInUp}
                    whileHover={{ y: -10, scale: 1.03 }}
                    transition={{ type: 'spring', stiffness: 300, damping: 10 }}
                    className="group bg-white rounded-3xl p-8 text-left shadow-lg hover:shadow-2xl hover:shadow-[#242A53]/10 border border-transparent hover:border-gray-200 transition-shadow duration-300"
                  >
                     <div className="bg-[#c0cccc]/40 text-[#242A53] w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-md group-hover:bg-[#242A53] group-hover:text-white transition-colors duration-300">
                       <FontAwesomeIcon icon={faThumbsUp} className="text-3xl" />
                     </div>
                    <h3 className="text-2xl font-bold text-[#242A53] mb-3 group-hover:text-[#242A53] transition-colors duration-300">Usabilidade</h3>
                    <p className="text-gray-700 text-lg leading-relaxed">
                      Focamos em interfaces intuitivas e processos simples, tornando a tecnologia fácil de usar para você e seus clientes.
                    </p>
                  </motion.div>
                </motion.div>
              </div>
            </section>
          </Element>

          {/* Seção Serviços - Sem fundos coloridos, mais clean */}
          <section id="enviar-mensagem" className="py-24 px-4 md:px-8 bg-white overflow-hidden">
             <motion.h2 variants={fadeInUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.5 }} className="text-4xl md:text-5xl font-extrabold text-[#242A53] mb-20 text-center">Nossas Principais Soluções</motion.h2>

            <div className="container mx-auto max-w-6xl space-y-24">

              {/* ===== SCHIMPEDIDOS (QR MENU) - ATUALIZADO ===== */}
              <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
                  <motion.div 
                    variants={fadeInLeft} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.3 }}
                    className="md:w-1/2 text-center md:text-left"
                  >
                    <div className="inline-block bg-[#c0cccc]/40 text-[#242A53] p-4 rounded-2xl mb-5 shadow-sm">
                       <FontAwesomeIcon icon={faQrcode} className="text-3xl" />
                    </div>
                    
                    {/* --- TEXTO ATUALIZADO --- */}
                    <h3 className="text-4xl font-bold text-[#242A53] mb-3">SchimPedidos</h3>
                    <p className="text-2xl text-gray-700 font-medium mb-5">A revolução para o seu restaurante.</p>
                   
                    <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                      Modernize seu estabelecimento com a plataforma completa de cardápio digital. Permita que seus clientes façam pedidos direto da mesa ou via WhatsApp, e gerencie tudo em um painel em tempo real.
                    </p>
                    {/* --- CHECKLIST ATUALIZADO --- */}
                    <div className="space-y-4 text-lg text-gray-700 mb-8">
                      <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Pedidos na mesa via QR Code (sem app).</span></div>
                      <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Painel de gestão em tempo real para cozinha.</span></div>
                      <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Integração nativa com pedidos via WhatsApp.</span></div>
                      <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Aumente seu ticket médio e reduza erros.</span></div>
                    </div>
                   
                   {/* Botões (Mantidos como estavam) */}
                   <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-5 mt-4">
                      <Link to="faleconosco" smooth={true} duration={500} className="inline-block text-[#242A53] font-semibold text-lg group hover:text-[#3a417a]">
                        Solicitar Demonstração <FontAwesomeIcon icon={faArrowRight} className="ml-2 transform group-hover:translate-x-1 transition-transform duration-200" />
                      </Link>
                      
                      <motion.a
                        href="https://schimpedidos.web.app"
                        target="_blank"
                        rel="noopener noreferrer"
                        whileHover={{ scale: 1.05, y: -2 }}
                        whileTap={{ scale: 0.98 }}
                        className="w-full sm:w-auto bg-white text-[#242A53] font-bold py-3 px-6 rounded-full border border-gray-200 hover:bg-gray-50 transition-colors duration-300 shadow-md flex items-center justify-center gap-2 cursor-pointer"
                      >
                        Conhecer o Produto
                        <FontAwesomeIcon icon={faArrowRight} className="text-sm" />
                      </motion.a>
                    </div>

                 </motion.div>
                 <motion.div 
                    variants={fadeInRight} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.3 }}
                    className="md:w-1/2 flex justify-center items-center"
                  >
                    <motion.div 
                      whileHover={{ rotate: 0, scale: 1.05 }}
                      className="w-full max-w-md h-80 bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl shadow-xl flex items-center justify-center relative p-6 transform rotate-3 transition-transform duration-300"
                    >
                       <FontAwesomeIcon icon={faMobileAlt} className="text-gray-400 text-8xl opacity-50 absolute -top-8 -left-8 transform -rotate-12" />
                       <p className="text-gray-800 font-semibold text-center z-10 text-2xl">Seu cliente faz o pedido, você recebe no painel!</p>
                       <FontAwesomeIcon icon={faQrcode} className="text-gray-400 text-8xl opacity-50 absolute -bottom-8 -right-8 transform rotate-12" />
                    </motion.div>
                 </motion.div>
              </div>

              {/* App Academias */}
              <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
                 <motion.div 
                    variants={fadeInLeft} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.3 }}
                    className="md:w-1/2 flex justify-center items-center md:order-2"
                  >
                    <motion.div 
                      whileHover={{ rotate: 0, scale: 1.05 }}
                      className="w-full max-w-md h-80 bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl shadow-xl flex items-center justify-center relative p-6 transform -rotate-3 transition-transform duration-300"
                    >
                      <FontAwesomeIcon icon={faDumbbell} className="text-gray-400 text-8xl opacity-50 absolute -top-8 -right-8 transform rotate-12" />
                       <p className="text-gray-800 font-semibold text-center z-10 text-2xl">Gerencie sua academia com tecnologia!</p>
                       <FontAwesomeIcon icon={faTv} className="text-gray-400 text-8xl opacity-50 absolute -bottom-8 -left-8 transform -rotate-12" />
                    </motion.div>
                 </motion.div>
                 <motion.div 
                    variants={fadeInRight} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.3 }}
                    className="md:w-1/2 text-center md:text-left md:order-1"
                  >
                   <div className="inline-block bg-[#c0cccc]/40 text-[#242A53] p-4 rounded-2xl mb-5 shadow-sm">
                       <FontAwesomeIcon icon={faDumbbell} className="text-3xl" />
                    </div>
                   <h3 className="text-4xl font-bold text-[#242A53] mb-5">App para Academias</h3>
                   <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                     Solução completa para gestão e interação com alunos. Controle de planos, treinos personalizados, agendamentos e monitoramento de lotação.
                   </p>
                   <div className="space-y-4 text-lg text-gray-700 mb-8">
                     <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Gestão simplificada de pagamentos e acessos.</span></div>
                     <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Engajamento do aluno com treinos e progresso.</span></div>
                     <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Otimização do espaço com controle de lotação.</span></div>
                   </div>
                   <Link to="faleconosco" smooth={true} duration={500} className="inline-block text-[#242A53] font-semibold text-lg group hover:text-[#3a417a]">
                     Ver Funcionalidades <FontAwesomeIcon icon={faArrowRight} className="ml-2 transform group-hover:translate-x-1 transition-transform duration-200" />
                   </Link>
                 </motion.div>
              </div>

               {/* Chatbot */}
              <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
                 <motion.div 
                    variants={fadeInLeft} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.3 }}
                    className="md:w-1/2 text-center md:text-left"
                  >
                    <div className="inline-block bg-[#c0cccc]/40 text-[#242A53] p-4 rounded-2xl mb-5 shadow-sm">
                       <FontAwesomeIcon icon={faRobot} className="text-3xl" />
                    </div>
                   <h3 className="text-4xl font-bold text-[#242A53] mb-5">Chatbot Inteligente</h3>
                   <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                     Automatize o atendimento e aumente suas vendas. Nosso chatbot responde instantaneamente 24/7, integrado ao WhatsApp, Instagram e seu site.
                   </p>
                   <div className="space-y-4 text-lg text-gray-700 mb-8">
                     <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Atendimento ininterrupto, sem perder clientes.</span></div>
                     <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Aumento da taxa de conversão e qualificação de leads.</span></div>
                     <div className="flex gap-3 items-center"><FontAwesomeIcon icon={faCheck} className="text-[#242A53] text-xl" /> <span>Libera sua equipe para tarefas estratégicas.</span></div>
                   </div>
                    <Link to="faleconosco" smooth={true} duration={500} className="inline-block text-[#242A53] font-semibold text-lg group hover:text-[#3a417a]">
                      Descobrir Como <FontAwesomeIcon icon={faArrowRight} className="ml-2 transform group-hover:translate-x-1 transition-transform duration-200" />
                    </Link>
                 </motion.div>
                 <motion.div 
                    variants={fadeInRight} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.3 }}
                    className="md:w-1/2 flex justify-center items-center"
                  >
                    <motion.div 
                      whileHover={{ rotate: 0, scale: 1.05 }}
                      className="w-full max-w-md h-80 bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl shadow-xl flex items-center justify-center relative p-6 transform rotate-3 transition-transform duration-300"
                    >
                      <FontAwesomeIcon icon={faRobot} className="text-gray-400 text-8xl opacity-50 absolute -top-8 -left-8 transform -rotate-12" />
                       <p className="text-gray-800 font-semibold text-center z-10 text-2xl">Atendimento automático e eficiente!</p>
                       <FontAwesomeIcon icon={faWhatsapp} className="text-gray-400 text-8xl opacity-50 absolute -bottom-8 -right-8 transform rotate-12" />
                    </motion.div>
                 </motion.div>
              </div>
            </div>
          </section>

          {/* Seção Outros Serviços - bg-gray-50 */}
          <section className="py-24 px-4 md:px-8 bg-gray-50">
             <motion.h2 variants={fadeInUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.5 }} className="text-4xl md:text-5xl font-extrabold text-[#242A53] mb-16 text-center">Desenvolvemos Sua Visão Digital</motion.h2>
            <motion.div 
              className="container mx-auto grid md:grid-cols-3 gap-10"
              variants={staggerContainer}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
            >
              {/* Card 1 */}
              <motion.div 
                variants={fadeInUp}
                whileHover={{ y: -10 }}
                transition={{ type: 'spring', stiffness: 300, damping: 10 }}
                className="group bg-white rounded-3xl p-8 text-center shadow-lg border border-gray-100 transition-shadow duration-300 hover:shadow-xl hover:border-gray-200"
              >
                  <div className="w-20 h-20 rounded-full bg-[#c0cccc]/40 text-[#242A53] flex items-center justify-center mb-6 mx-auto transition-colors duration-300 group-hover:bg-[#242A53] group-hover:text-white">
                   <FontAwesomeIcon icon={faCode} className="text-4xl" />
                 </div>
                <h3 className="text-2xl font-bold text-[#242A53] mb-3">Sistemas Customizados</h3>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Analisamos seus processos e criamos sistemas web sob medida para otimizar sua gestão e operações.
                </p>
              </motion.div>
              {/* Card 2 */}
              <motion.div 
                variants={fadeInUp}
                whileHover={{ y: -10 }}
                transition={{ type: 'spring', stiffness: 300, damping: 10 }}
                className="group bg-white rounded-3xl p-8 text-center shadow-lg border border-gray-100 transition-shadow duration-300 hover:shadow-xl hover:border-gray-200"
              >
                 <div className="w-20 h-20 rounded-full bg-[#c0cccc]/40 text-[#242A53] flex items-center justify-center mb-6 mx-auto transition-colors duration-300 group-hover:bg-[#242A53] group-hover:text-white">
                   <FontAwesomeIcon icon={faTv} className="text-4xl" />
                 </div>
                <h3 className="text-2xl font-bold text-[#242A53] mb-3">Softwares Especializados</h3>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Desenvolvemos softwares com funcionalidades específicas para atender demandas complexas do seu nicho de mercado.
                </p>
              </motion.div>
              {/* Card 3 */}
              <motion.div 
                variants={fadeInUp}
                whileHover={{ y: -10 }}
                transition={{ type: 'spring', stiffness: 300, damping: 10 }}
                className="group bg-white rounded-3xl p-8 text-center shadow-lg border border-gray-100 transition-shadow duration-300 hover:shadow-xl hover:border-gray-200"
              >
                 <div className="w-20 h-20 rounded-full bg-[#c0cccc]/40 text-[#242A53] flex items-center justify-center mb-6 mx-auto transition-colors duration-300 group-hover:bg-[#242A53] group-hover:text-white">
                   <FontAwesomeIcon icon={faMobileAlt} className="text-4xl" />
                 </div>
                <h3 className="text-2xl font-bold text-[#242A53] mb-3">Aplicativos Mobile</h3>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Criamos aplicativos nativos para Android e iOS, oferecendo uma experiência mobile fluida e conectada à sua marca.
                </p>
              </motion.div>
            </motion.div>
          </section>

          {/* Seção Benefícios Carrossel - Card ativo com a nova cor */}
          <section className="py-24 px-4 md:px-8 bg-white overflow-hidden">
             <motion.h2 variants={fadeInUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.5 }} className="text-4xl md:text-5xl font-extrabold text-[#242A53] mb-20 text-center">Impacto Real no Seu Negócio</motion.h2>
            <motion.div
              variants={fadeInUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }}
            >
              <Slider {...settingsDois}>
                {beneficios.map((beneficio, index) => {
                  const isMiddle = currentSlide === index;
                  return (
                    <div key={index} className="px-4 h-full pb-8">
                      <motion.div 
                        animate={{ 
                          scale: isMiddle ? 1.05 : 0.95, 
                          opacity: isMiddle ? 1 : 0.9 
                        }}
                        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                        // Card ativo com o gradiente suave da nova cor
                        className={`p-8 rounded-2xl text-lg text-center min-h-[300px] h-full flex flex-col items-center justify-center transition-colors duration-500 shadow-lg border ${isMiddle ? 'bg-gradient-to-br from-[#242A53] to-[#3a417a] text-white shadow-2xl shadow-[#242A53]/40 border-transparent' : 'bg-white text-gray-700 border-gray-200'}`}
                      >
                          <FontAwesomeIcon icon={beneficio.icon} className={`text-4xl mb-5 transition-colors duration-500 ${isMiddle ? 'text-white' : 'text-[#242A53]'}`} />
                         <p className="leading-relaxed">{beneficio.text}</p>
                      </motion.div>
                    </div>
                  );
                })}
              </Slider>
            </motion.div>
          </section>

          {/* CTA Final - Gradiente escuro e texto com a cor #c0cccc */}
          <Element name="faleconosco">
            <section className="py-24 px-4 md:px-8 bg-gradient-to-r from-[#242A53] to-[#1a1e3a] text-white text-center relative overflow-hidden">
               {/* Efeitos de luz sutis */}
               <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/3 -translate-y-1/3 opacity-50 blur-xl"></div>
               <div className="absolute bottom-0 right-0 w-80 h-80 bg-white/5 rounded-full translate-x-1/4 translate-y-1/4 opacity-50 blur-xl"></div>

              <motion.div 
                className="container mx-auto max-w-3xl relative z-10"
                variants={staggerContainer}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.3 }}
              >
                <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-extrabold mb-6 leading-tight">Pronto para Inovar?</motion.h2>
                {/* Texto secundário com a cor #c0cccc */}
                <motion.p variants={fadeInUp} className="text-xl md:text-2xl text-[#c0cccc] mb-10 leading-relaxed">
                  Vamos conversar sobre como a Schimborn Tech pode ajudar sua empresa a alcançar novos patamares com soluções digitais personalizadas.
                </motion.p>
                <motion.div variants={fadeInUp}>
                  <motion.a 
                    href="https://wa.me/4288673339?text=Olá,%20gostaria%20de%20agendar%20uma%20conversa%20sobre%20as%20soluções%20da%20Schimborn%20Tech." target="_blank" rel="noopener noreferrer"
                    className="inline-block bg-white text-[#242A53] font-bold py-4 px-10 rounded-full text-lg hover:bg-gray-100 transition-colors shadow-2xl shadow-black/20 duration-300"
                    whileHover={{ scale: 1.05, y: -2, boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)" }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Agendar Conversa Gratuita
                  </motion.a>
                </motion.div>
              </motion.div>
            </section>
          </Element>
          
        </main>

        {/* Footer - Novas cores de texto */}
        <footer className="bg-white text-gray-600 py-16 px-4 md:px-8 border-t border-gray-100">
          <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
            {/* Coluna 1: Logo e Descrição */}
            <div className="flex flex-col items-center md:items-start text-center md:text-left">
              <img src={logo} alt="Logo Schimborn Tech" className="h-14 w-14 mb-4" />
              <p className="text-gray-500 text-base">Criando o futuro digital do seu negócio em São Mateus do Sul e região.</p>
            </div>

            {/* Coluna 2: Links Rápidos */}
            <div>
              <h4 className="font-bold text-[#242A53] text-lg mb-4">Navegação</h4>
              <ul className="space-y-3">
                 <li><Link to="apresentacaosch" smooth={true} duration={500} offset={-80} className="hover:text-[#3a417a] transition-colors cursor-pointer">Quem Somos</Link></li>
                 <li><Link to="enviar-mensagem" smooth={true} duration={500} offset={-80} className="hover:text-[#3a417a] transition-colors cursor-pointer">Serviços</Link></li>
                 <li><Link to="trabalhos-section" smooth={true} duration={500} offset={-80} className="hover:text-[#3a417a] transition-colors cursor-pointer">Portfólio</Link></li>
                 <li><Link to="faleconosco" smooth={true} duration={500} className="hover:text-[#3a417a] transition-colors cursor-pointer">Contato</Link></li>
              </ul>
            </div>

            {/* Coluna 3: Contato */}
            <div>
               <h4 className="font-bold text-[#242A53] text-lg mb-4">Contato</h4>
               <ul className="space-y-3">
                 <li><a href="mailto:contato@schimborntech.com.br" className="hover:text-[#3a417a] transition-colors flex items-center gap-2"><FontAwesomeIcon icon={faEnvelope} className="w-4"/> contato@schimborntech.com.br</a></li>
                 <li><a href="https://wa.me/5542988673339?text=Olá!%20Estou%20entrando%20em%20contato%20através%20do%20site." target="_blank" rel="noopener noreferrer" className="hover:text-[#3a417a] transition-colors flex items-center gap-2"><FontAwesomeIcon icon={faWhatsapp} className="w-4"/> WhatsApp</a></li>
               </ul>
            </div>

            {/* Coluna 4: Redes Sociais */}
             <div>
               <h4 className="font-bold text-[#242A53] text-lg mb-4">Siga-nos</h4>
               <a href="https://www.instagram.com/schimborntech/" target="_blank" rel="noopener noreferrer" className="hover:text-[#3a417a] transition-colors flex items-center gap-2">
                 <FontAwesomeIcon icon={faInstagram} className="w-5 h-5"/> @schimborntech
               </a>
             </div>
          </div>
          <div className="text-center text-gray-400 border-t border-gray-100 pt-8 mt-12 text-sm">
            <p>Schimborn Tech &copy; {new Date().getFullYear()} Todos os direitos reservados.</p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default App;